import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePlatformRole } from '@/lib/route-guards';
import { useMember } from '@/lib/use-session';
import { CreateResourceForm } from './-components/CreateResourceForm';

export const Route = createFileRoute('/_authed/admin/resources/new/')({
  beforeLoad: ({ context }) => {
    requirePlatformRole(context, {
      role: 'admin',
      bounceTo: () => redirect({ to: '/resources' }),
    });
  },
  component: NewResourcePage,
});

function NewResourcePage() {
  const me = useMember();
  if (me === null) return null;
  const isAdmin = me.platformRole === 'admin';
  return (
    <CreateResourceForm
      isAdmin={isAdmin}
    />
  );
}
